<template>
  <v-dialog :model-value="isOpen" width="635" v-on:keydown.stop persistent>
    <div class="dialog">
      <div class="welcome-to-plan-close-button-container">
        <v-btn
          variant='text'
          color="grey"
          icon="mdi-close"
          @click="close"></v-btn>
      </div>

      <div class="dialog-header">
        <img
          alt="Welcome to Plan"
          class="welcome-to-plan-background"
          src="@/assets/welcome-to-plan-background.svg"
        />
        <div class="dialog-header-title-container">
          <p class="dialog-header-title-top" v-if="plan !== 'trial'">Welcome to</p>
          <p class="dialog-header-title">
            <template v-if="plan === 'trial'">
              Your Free Trial Has Started!
            </template>
            <template v-else>
              Continuum Design {{ plan }}!
            </template>
          </p>
        </div>
      </div>

      <div class="welcome-to-plan-info mb-6">
        <p class="welcome-to-plan-text mb-4">
          <template v-if="plan === 'trial'">
            Thank you! Your 4-week free trial is now active.
          </template>
          <template v-else>
            Thank you for subscribing to the <span class="text-capitalize">{{ plan }}</span> plan!
          </template>
        </p>

        <p class="welcome-to-plan-text mb-4">
          <template v-if="plan === 'trial'">
            Your credit card details have been processed successfully and your card will be charged
            ${{ activeSubscription?.subscriptionDetails?.nextBillingAmount }} (plus local tax if
            applicable) on {{ nextBillingDate }}, unless you cancel before then.
          </template>
          <template v-else>
            Your payment of ${{ activeSubscription?.subscriptionDetails?.nextBillingAmount }} (plus local tax if
            applicable) has been processed successfully, and your subscription is now active until {{ nextBillingDate }}.
          </template>
        </p>

        <p class="welcome-to-plan-text">
          To help you get started, check out:
        </p>
        <ul class="welcome-to-plan-list mb-4">
          <li class="welcome-to-plan-text">
            <strong>
              <a target="_blank" href="https://www.youtube.com/watch?v=yb7jAeg9Daw">Intro
                Video</a>:
            </strong> A quick walkthrough of the Continuum Design tool.
          </li>
          <li class="welcome-to-plan-text">
            <strong>
              <a target="_blank" href="https://qlerify.com/help">Help Center</a>:
            </strong> Explore guides and FAQs for step-by-step support.
          </li>
        </ul>

        <p class="welcome-to-plan-text">
          <template v-if="plan === 'trial'">
            Enjoy exploring all the features of the Continuum Design tool!
          </template>
          <template v-else>
            Enjoy using Continuum Design!
          </template>
        </p>
      </div>

      <div class="d-flex justify-center pb-6">
        <v-btn
          size="large"
          variant="flat"
          @click="close"
          class="welcome-to-plan-button"
        >
          Got it!
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import format from 'date-fns/format'
import { mapState } from 'vuex'

export default {
  name: 'welcome-to-trial-dialog',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    },
    plan: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      subscriptionUsers: state => state.payments.subscriptionUsers,
      activeSubscription: state => state.payments.activeSubscription
    }),
    nextBillingDate: function () {
      const nextBillingDate = this.activeSubscription?.subscriptionDetails?.nextBillingDate
      if (nextBillingDate) {
        return format(new Date(nextBillingDate), 'MMMM dd, yyyy')
      }
      return ''
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.dialog {
  position: relative;
  border: 1px solid var(--light-1);
  background: var(--light-1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
}

.welcome-to-plan-close-button-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

.dialog-header {
  position: relative;
}

.welcome-to-plan-background {
  width: 100%;
  aspect-ratio: 635/283;
}

.dialog-header-title-container {
  top: 50%;
  left: 50%;
  width: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  transform: translate(-50%, -50%);
}

.dialog-header-title-top {
  font-size: 25px;
  font-weight: 400;
  text-align: center;
  line-height: 32.5px;
  font-family: Faktum, sans-serif;
  color: #1F2833;
}

.dialog-header-title {
  font-size: 52px;
  font-weight: 400;
  max-width: 435px;
  text-align: center;
  line-height: 62.4px;
  letter-spacing: -1.5px;
  text-transform: capitalize;
  font-family: Faktum, sans-serif;
  color: #1F2833;
}

.welcome-to-plan-info {
  padding: 16px 24px;
}

.welcome-to-plan-text {
  font-size: 16px;
  line-height: 20.8px;
  font-family: Faktum, sans-serif;
}

.welcome-to-plan-list {
  list-style-position: inside;

  .welcome-to-plan-text {
    padding-left: 8px;
  }
}

.welcome-to-plan-button {
  min-width: 140px;
}

[data-theme="dark"] .welcome-to-plan-list a {
  color: var(--blue-3);
}
</style>
